import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "@react/shared/ui/Button"
import Popover from "./Popover"
import AssignmentFields, { fieldsToAttrs, initialFields } from "./AssignmentFields"
import { formatLong } from "../lib/dates"
import { formatHours } from "../lib/hours"

const EditPopover = ({ rect, assignment, board, canWrite, onSave, onDelete, onClose }) => {
  const [fields, setFields] = useState(() => initialFields(board.settings, assignment))
  const user = board.users.find(item => item.id === assignment.user_id)

  const submit = event => {
    event.preventDefault()
    if (!fields.projectId) return
    onSave(assignment.id, { projectId: Number(fields.projectId), attrs: fieldsToAttrs(fields) })
    onClose()
  }

  return (
    <Popover
      rect={rect}
      width={348}
      title={user ? user.name : I18n.t("project_planning.unknown_person")}
      subtitle={`${formatLong(assignment.date)} · ${formatHours(assignment.hours)}`}
      onClose={onClose}
      footer={canWrite && (
        <>
          <Button variant="danger-ghost" size="sm" onClick={() => { onDelete([assignment.id]); onClose() }}>
            <FontAwesomeIcon icon="trash-can" className="text-[11px]" />
            {I18n.t("project_planning.actions.delete")}
          </Button>
          <Button variant="ghost" size="sm" className="ml-auto" onClick={onClose}>{I18n.t("project_planning.actions.cancel")}</Button>
          <Button variant="primary" size="sm" disabled={!fields.projectId} onClick={submit}>{I18n.t("project_planning.actions.save")}</Button>
        </>
      )}
    >
      <form onSubmit={submit}>
        <fieldset disabled={!canWrite} className="contents">
          <AssignmentFields fields={fields} onChange={setFields} projects={board.projects} settings={board.settings} />
        </fieldset>
        <button type="submit" className="hidden" />
      </form>
    </Popover>
  )
}

export default EditPopover
